import { fetchFromApi, optionsForPostRequest } from 'api/index';

const sendConsultationRegistration = values =>
  fetchFromApi('/data-availability/consultation', optionsForPostRequest(values));

export default {
  sendConsultationRegistration,
};
